import { Col, Row } from "antd";
// import { useSelector } from "react-redux";
import DashbordSidebar from "../../components/DashboardSidebar";
import { useEffect, useState } from "react";
import { Get } from "../../config/api/get";
import { BOOKING } from "../../config/constants/api";
import { useDispatch, useSelector } from "react-redux";
// import { extractTime } from "../../config/helpers";
import { useNavigate } from "react-router";
import socket from "../../config/socket/index.js";
import BookingCardsList from "../../components/BookingCardList/index.js";
import {
  resetRideState,
} from "../../redux/slice/rideSlice";
// import dicon from "../../assets/d-icon.png";
// import dicon2 from "../../assets/d-icon2.png";
// import dicon4 from "../../assets/d-icon4.png";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Line } from "react-chartjs-2";
// import { Bar } from "react-chartjs-2";
// import { Get } from "../../config/api";
// import { CHAUFFEUR } from "../../config/constants/api";
// import { Get } from "../../config/api/get";
// import { ADMIN } from "../../config/constants/api";

// ChartJS.register(CategoryScale);
// ChartJS.register(LinearScale);
// ChartJS.register(PointElement);
// ChartJS.register(LineElement);
// ChartJS.register(BarElement);
// ChartJS.register(Title);
// ChartJS.register(Tooltip);
// ChartJS.register(Legend);

// const data = {
//   labels: [
//     "Nov 2015",
//     "March 2016",
//     "July 2017",
//     "August 2018",
//     "Sep 2019",
//     "Oct 2020",
//     "July 2021",
//   ],
//   datasets: [
//     {
//       label: "Users",
//       data: [30000, 20000, 30000, 25000, 35000, 49000, 40000],
//       fill: true,
//       backgroundColor: "rgba(157,98,245,0.2)",
//       borderColor: "#9D62F5",
//       pointRadius: 3,
//     },
//   ],
// };

// const options = {
//   maintainAspectRatio: false,
//   responsive: true,
//   scales: {
//     y: {
//       title: {
//         display: true,
//         text: "Users",
//         color: "#000000",
//       },
//       min: 0,
//       max: 50000,
//     },
//     x: {
//       title: {
//         display: true,
//         text: "Months",
//         color: "#000000",
//       },
//     },
//   },
//   plugins: {
//     legend: {
//       display: false,
//     },
//   },
// };

const Dashboard = () => {
  const [upcomingBookings, setUpcomingBookings] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const getOngoingBooking = async () => {
    Get(BOOKING.getChauffeurOngoingBooking, token)
      .then((response) => {
        if (response?.status) {
          navigate(`/ride/${response?.data?._id}`, {
            state: { id: response?.data?._id },
          });
        } else {
          dispatch(resetRideState());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getMyUpcomingBookings = async () => {
    Get(BOOKING.getMyUpcomingBooking, token)
      .then((response) => {
        if (response?.status) {
          setUpcomingBookings(response?.data?.docs);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Ongoing Booking", err);
      });
  };
  useEffect(() => {
    getOngoingBooking();
    getMyUpcomingBookings();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    socket.on("notification", (data) => {
      if (data?.title === "New Booking Alert") {
        getMyUpcomingBookings();
        // setUpcomingBookings((prev) => [data?.payload?.booking, ...prev]);
      }
    });
    return () => {
      socket.off("newBooking");
    };
    // eslint-disable-next-line
  }, []);
  // const token = useSelector((state) => state.user.userToken);
  // const [info, setInfo] = useState(null);
  // const getDashboardInfo = () => {
  //   Get(CHAUFFEUR.getDashboardInfo, token)
  //     .then((response) => {
  //       if (response?.status) {
  //         setInfo(response?.data);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Error fetching dashboard info ", err);
  //     });
  // };
  // useEffect(() => {
  //   getDashboardInfo();
  //   // eslint-disable-next-line
  // }, []);
  // const formatinHours = (minutes) => {
  //   return minutes / 60;
  // };
  const handleBookingClick = (id) => {
    console.log(`Booking clicked: ${id}`);
    // Navigate or show details here
    navigate("/ride/" + id, {
      state: { id: id },
    });
  };
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="" style={{ margin: "20px 0" }}>
                        <h3 className="heading-28">Current Bookings:</h3>
                      </div>

                      {/* <Row gutter={[20, 10]} style={{ background: "#fff" }}>
                        {Array.isArray(upcomingBookings) &&
                          upcomingBookings.map((booking, index) => (
                            <Col xs={24} md={12} key={index}>
                              <div
                                className="boxDetails analytics1 bg-parent dashboard-right-card"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  navigate("/ride/" + booking?._id, {
                                    state: { id: booking?._id },
                                  });
                                }}
                              >
                                <p>Customer Name : {booking?.customerName}</p>
                                <p>
                                  Pk-up Address :{" "}
                                  {booking?.pickupLocation?.address}
                                </p>
                                <p>
                                  Dr-off Address :{" "}
                                  {booking?.dropoffLocation?.address || "-"}
                                </p>
                                <p>Service Type : {booking?.serviceType}</p>
                                <p>
                                  Booking Time : {extractTime(booking?.time)}
                                </p>
                                <p>
                                  Req Duration :{" "}
                                  {formatinHours(booking?.duration) >= 1
                                    ? `${formatinHours(
                                        booking?.duration
                                      )} Hours`
                                    : booking?.duration + " Minutes"}
                                </p>
                              </div>
                            </Col>
                          ))}
                       
                      </Row> */}
                      <BookingCardsList
                        bookings={upcomingBookings}
                        onBookingClick={handleBookingClick}
                      />
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
